import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'packages/theming';
import { Topic } from 'types';
import { Box, constants, Text } from '@match/react-component-library';

const { SEMANTIC_COLOR_NAME, SPACE, TYPOGRAPHY } = constants;

interface TopicsProps {
  topics?: Topic[];
}

const Topics = ({ topics }: TopicsProps) => {
  if (!topics) {
    return null;
  }
  const topicsList = topics.map((topic, index) => {
    return (
      <li key={topic.id}>
        <Box marginY={SPACE.XLARGE} key={index}>
          <StyledLink to={`${topic.categoryId}/${topic.id}`}>
            <Text typography={TYPOGRAPHY.STANDARD_BODY} color={SEMANTIC_COLOR_NAME.DARK}>
              {topic.title}
            </Text>
          </StyledLink>
        </Box>
      </li>
    );
  });

  return <ul>{topicsList}</ul>;
};

const StyledLink = styled(Link)({
  ':hover': {
    textDecoration: 'none',
  },
});

export default Topics;
